import React, { Fragment } from 'react'
import styled from 'styled-components'
import { useSelector } from 'react-redux'
import Input from '../../typography/Input'
import AnalyzeSvg from '../../../static/images/questskills/icon_analyze.svg'
import CommunicateSvg from '../../../static/images/questskills/icon_communicate.svg'
import ExploreSvg from '../../../static/images/questskills/icon_explore.svg'
import ReasonSvg from '../../../static/images/questskills/icon_reason.svg'
import ReflectSvg from '../../../static/images/questskills/icon_reflect.svg'
import GenericSkillSvg from '../../../static/images/questskills/icon_skill_generic.svg'
import ReactTooltip from 'react-tooltip'

const getIconForGroup = groupId => {
  switch (groupId) {
    case 1:
      return ReflectSvg
    case 2:
      return CommunicateSvg
    case 3:
      return ReasonSvg
    case 4:
      return AnalyzeSvg
    case 5:
      return ExploreSvg
    default:
      return GenericSkillSvg
  }
}

const SkillLi = styled.li`
  display: flex;
  align-items: center;

  img {
    padding: 4px;
    margin-right: 5px;
  }
`

const LinkedSkillsReadonly = ({ linkedSkills }) => {
  const frameworkSkills = useSelector(state => state.frameworkskills.items)
  const frameworkSkillGroups = useSelector(
    state => state.frameworkskills.skillGroups
  )

  const namedSkills = linkedSkills.map(skill => {
    const fs = frameworkSkills.find(fs => fs.id === skill.framework_skill_id)
    return {
      ...fs,
      group: frameworkSkillGroups.find(
        fsg => fsg.id === fs.framework_skill_group_id
      )
    }
  })
  
  return (
    <ul>
      {namedSkills.map(skill => (
        <SkillLi key={skill.id}>
          <img
            alt={skill.group.name}
            src={getIconForGroup(skill.group.id)}
            data-tip={skill.group.name}
            data-for={`skill-group-tooltip-${skill.id}`}
          />
          <Input>
            {skill.group.name}: {skill.name}
          </Input>
          <ReactTooltip
            id={`skill-group-tooltip-${skill.id}`}
            effect="solid"
          />
        </SkillLi>
      ))}
    </ul>
  )
}

export default LinkedSkillsReadonly



// WEBPACK FOOTER //
// ./src/components/mycourses/Activities/LinkedSkillsReadOnly.js